"use strict";

import React from "react";
import _ from "lodash";
import { toUnicode } from "../../utils/DomainUtils";

class DomainTableRow extends React.Component {
  static defaultProps = {
    selected: false,
  };

  render() {
    const { domain, selected, ...other } = this.props;
    const hasDesign = _.isNumber(domain.site_design_id);
    const isDisabled = domain.disabled > 0;

    let className = "si-table-row";
    if (this.props.selected) {
      className += " selected";
    }

    const designName = hasDesign ? domain.design_name : "";

    return (
      <div {...other} className={className}>
        <div style={{ fontSize: "var(--body-size-base)", fontWeight: 300 }}>
          {toUnicode(domain.domain_name || "")}
        </div>
        <div style={{ fontSize: "var(--body-size-small)", lineHeight: "1.2" }}>{designName}</div>
      </div>
    );
  }
}

export default DomainTableRow;
